import { useMemo } from 'react';
import { useQuery } from '@common-fe/common-fe';
import _ from 'lodash';

import { api } from '@/api';
import { Pagination, PaginationParams } from '@/common/types';
import { API_URL } from '@/dtos';

import {
  FieldLevelAccessListItemResponse,
  IFieldLevelAccessProperties,
  IFieldLevelAccessSetup,
} from '../role.types';

export const QUERY_KEY = 'useGetFieldLevelAccessListQueryKey';

export interface FieldLevelAccessListSearchParams extends PaginationParams {
  enabled?: boolean;
  currentRoleId?: string;
}

const useGetFieldLevelAccessListQuery = ({
  page,
  perPage,
  searchString,
  enabled = true,
  sortBy,
}: FieldLevelAccessListSearchParams) => {
  const { isError, isSuccess, data, isLoading } = useQuery(
    [QUERY_KEY, page, perPage, searchString, sortBy, enabled],
    () =>
      // TODO: the type is missing
      api.get<Pagination<FieldLevelAccessListItemResponse>>(API_URL.ORGANIZATION_PROPERTIES_STATE_CONFIGS, {
        params: _.pickBy({
          page: page - 1,
          size: perPage,
          sort: `name,${sortBy}`,
          search_value: searchString || '',
        }),
      }),
    {
      retry: 0,
      enabled,
    }
  );

  const currentData = useMemo<IFieldLevelAccessSetup[]>(() => {
    const list = data?.data?.content || [];
    return list.map((item) => ({
      id: `${item.id}`,
      name: item.name,
      description: item.description,
      roles: item.roles_applied_to,
      properties: item.properties as IFieldLevelAccessProperties,
      overridableProperties: item.overridable_properties as IFieldLevelAccessProperties,
    }));
  }, [data?.data?.content]);

  const dropdownOptions = useMemo(() => {
    return currentData.map((item) => ({
      key: item.id,
      title: item.name,
      value: item.name,
    }));
  }, [currentData]);

  const total = useMemo(() => data?.data?.totalElements || null, [data?.data.totalElements]);

  return {
    total,
    data: currentData,
    dropdownOptions,
    isLoading,
    isSuccess,
    isError,
  };
};

export default useGetFieldLevelAccessListQuery;
